import { apiClient } from '@shoots/auth'

export type PaymentMethodType = 'card' | 'us_bank_account'

export interface PaymentIntentResponse {
  clientSecret: string
  paymentIntentId: string
  /** Present once the server prices the intent (create + recalc paths). */
  basePriceCents?: number
  serviceFeeCents?: number
  chargedCents?: number
  method?: PaymentMethodType
}

export async function createPaymentIntent(
  eventId: string,
  inviteId: string,
  method?: PaymentMethodType
): Promise<PaymentIntentResponse> {
  return apiClient.post<PaymentIntentResponse>(
    '/functions/v1/gathering-payment-intent',
    { event_id: eventId, invite_id: inviteId, ...(method ? { method } : {}) }
  )
}
